import { jsx as o } from "react/jsx-runtime";
import { Button as r } from "@datamole/wds-component-button";
import { faChevronDown as s } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as p } from "@fortawesome/react-fontawesome";
import { forwardRef as c } from "react";
import { useComboboxContext as f } from "../../hooks/use-combobox-context.js";
const a = c((t, e) => {
  const { children: n, ...m } = t, { disabled: i } = f();
  return /* @__PURE__ */ o(r, { ...m, ref: e, type: "button", variant: "text", size: "sm", disabled: i, tabIndex: -1, children: /* @__PURE__ */ o(r.Icon, { children: n ?? /* @__PURE__ */ o(p, { icon: s }) }) });
});
a.displayName = "Combobox.Trigger.Toggle";
export {
  a as Toggle
};
